import { v4 as uuidv4 } from "uuid";
import { IBaoCaoTab } from "../../../model/respone/bao-cao/IBaoCaoTab";
import { IBaoCaoActionTypes } from "../../action-types/bao-cao/IBaoCaoActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IBaoCaoReducer } from "./../../reducer-model/bao-cao/IBaoCaoReducer";
import { IBaoCaoRequest } from "../../../model/request/bao-cao/IBaoCaoRequest";
import { getThuTatCaHkNhSync } from "../../../helpers/thuTatCaConfig";
const initTab: IBaoCaoTab = {
  id: uuidv4(),
  status: eReducerStatusBase.is_not_initialization,
  title: "Untitled",
  isShowFilter: true,
  request: {
    id_hes: [],
    hoc_ky: 0,
    nam_hoc: "",
    id_lops: [],
    id_nganhs: [],
    id_thu_chis: [],
    khoa_hocs: [],
    id_khoi_nganhs: [],
    page_index: 0,
    page_size: 100,
    search_key: "",
    id_chuyen_nganhs: [],
    id_khoas: [],
    id_hinh_thuc_thanh_toans: [],
    loai_phieu: "thu",
    trang_thai_phieu: "hoan-thanh",
    filter_phamvi: getThuTatCaHkNhSync() ? "all" : "ky",
    nguoi_thu: "",
    // Người thu của nhóm báo cáo nhập học (11.x) — lọc theo id_cb_thu, không theo tên gõ tay.
    id_cb_thus: [],
    id_co_sos: [],
    id_ngan_hangs: [],
    id_doi_tuongs: [],
    tinh_chat_hocs: [],
    ky_dang_kys: [],
    id_nhom_thu_chis: [],
    trang_thai_hocs: [],
    lay_hoa_don_dich_vu: false,
    nam_tai_chinh: new Date().getFullYear(),
  } as IBaoCaoRequest,
  result: "",
} as IBaoCaoTab;

const iniState: IBaoCaoReducer = {
  tabs: [initTab],
  selectedId: initTab.id,
};
export const baoCaoReducer = (
  state: IBaoCaoReducer = iniState,
  action: IBaoCaoActionTypes,
): IBaoCaoReducer => {
  switch (action.type) {
    case "BAO_CAO_LOAD_START":
      return {
        ...state,
        tabs: state.tabs.map((g) => {
          if (action.payload.selectedTabId === g.id) {
            return {
              ...g,
              status: eReducerStatusBase.is_loading,
              result: "",
            };
          }
          return g;
        }),
      };
    case "BAO_CAO_LOAD_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((g) => {
          if (action.payload.selectedTabId === g.id) {
            return {
              ...g,
              status: eReducerStatusBase.is_completed,
              result: action.payload.data,
            };
          }
          return g;
        }),
      };
    case "BAO_CAO_LOAD_ERRR":
      return {
        ...state,
        tabs: state.tabs.map((g) => {
          if (action.payload.selectedTabId === g.id) {
            return {
              ...g,
              status: eReducerStatusBase.is_completed,
              result: action.payload.data,
            };
          }
          return g;
        }),
      };
    case "BAO_CAO_CHANGE_REQUEST":
      return {
        ...state,
        tabs: state.tabs.map((g) => {
          if (action.payload.selectedTabId === g.id) {
            return {
              ...g,
              request: {
                ...g.request,
                ...action.payload.data,
              },
            };
          }
          return g;
        }),
      };
    case "BAO_CAO_ADD_NEW_TAB":
      const id = uuidv4();
      return {
        ...state,
        selectedId: id,
        tabs: [
          {
            title: "Untitled",
            id: id,
            request: {
              ...initTab.request,
            } as IBaoCaoRequest,
            isShowFilter: true,
            result: "",
            status: eReducerStatusBase.is_not_initialization,
          } as IBaoCaoTab,
          ...state.tabs,
        ],
      };
    case "BAO_CAO_REMOVE_TAB":
      return {
        ...state,
        tabs: state.tabs.filter((t) => t.id !== action.payload),
      };
    case "BAO_CAO_CHANGE_SELECTED_TAB":
      return {
        ...state,
        selectedId: action.payload,
      };
    case "BAO_CAO_EXPORT_BAO_CAO_START":
      return {
        ...state,
        tabs: state.tabs.map((g) =>
          g.id === action.payload.selectedTabId
            ? { ...g, status: eReducerStatusBase.is_exporting }
            : g,
        ),
      };

    case "BAO_CAO_EXPORT_BAO_CAO_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((g) =>
          g.id === action.payload.selectedTabId
            ? { ...g, status: eReducerStatusBase.is_completed }
            : g,
        ),
      };

    case "BAO_CAO_EXPORT_BAO_CAO_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((g) =>
          g.id === action.payload.selectedTabId
            ? {
                ...g,
                status: eReducerStatusBase.is_completed,
                result: action.payload.data,
              }
            : g,
        ),
      };

    case "BAO_CAO_SHOW_HIDE_FILTER":
      return {
        ...state,
        tabs: state.tabs.map((g) =>
          g.id === action.payload.selectedTabId
            ? {
                ...g,
                isShowFilter: action.payload.data,
              }
            : g,
        ),
      };
    case "BAO_CAO_CHANGE_BAOCAO":
      return {
        ...state,
        tabs: state.tabs.map((g) =>
          g.id === action.payload.selectedTabId
            ? {
                ...g,
                request: {
                  ...g.request,
                  bao_cao: action.payload.data,
                },
                title: action.payload.data.name,
              }
            : g,
        ),
      };

    default:
      return state;
  }
};
